(function(){
  var els=document.querySelectorAll('.oped .oped-reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.14});
    els.forEach(function(el){io.observe(el);});
  }else{els.forEach(function(el){el.classList.add('in');});}
  var car=document.querySelector('.oped-carousel');
  if(car){
    var prev=document.querySelector('.oped-arrow--prev'),next=document.querySelector('.oped-arrow--next');
    var step=function(){var c=car.querySelector('.oped-card');return c?c.offsetWidth+22:300;};
    if(prev)prev.addEventListener('click',function(){car.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){car.scrollBy({left:step(),behavior:'smooth'});});
    var down=false,moved=false,sx=0,sl=0;
    car.addEventListener('pointerdown',function(e){down=true;moved=false;sx=e.pageX;sl=car.scrollLeft;});
    car.addEventListener('pointermove',function(e){if(!down)return;var d=e.pageX-sx;if(Math.abs(d)>6)moved=true;car.scrollLeft=sl-d;});
    var end=function(){down=false;};
    car.addEventListener('pointerup',end);car.addEventListener('pointerleave',end);
    car.addEventListener('click',function(e){if(moved){e.preventDefault();}},true);
  }
})();